// extracted by mini-css-extract-plugin
module.exports = {"loading":"JournalDetailList_loading__1V1s4","container":"JournalDetailList_container__mD_8G"};